import { packageQuerySchema, packageStatusSchema, questionShape } from '@consigli/types';
import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
const packageChatRequestSchema = z
    .object({
    project_id: z.number().int(),
    package_id: z.string().uuid(),
})
    .strict()
    .transform(mapToCamelCase);
export const packageChatStatusResponseSchema = packageStatusSchema;
export const packageChatStatusRequestSchema = packageChatRequestSchema;
export const packageChatQueryResponseSchema = packageQuerySchema;
// conversation_id scopes the turn to one chat session, letting the agent answer
// with the earlier turns in context. Optional to mirror the API: the backend
// reads a missing id as a stateless one-off question rather than rejecting it.
export const packageChatQueryRequestSchema = z
    .object({
    ...questionShape,
    conversation_id: z.string().uuid().optional(),
})
    .strict()
    .transform(mapToCamelCase);
